import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = {
  containerStyle: {
    maxWidth: 300,
    margin: '0 auto',
    textAlign: 'center',
    marginTop: 'calc(50vh - 225px)',
  },
  logoStyle: {
    maxWidth: 300,
    width: '100%',
    textAlign: 'center',
  },
};

const AuthWrapper = ({
  classes, children, onKeyPress, logo,
}) => (
  <div className={classes.containerStyle} onKeyPress={onKeyPress}>
    <img className={classes.logoStyle} src={logo} alt="Logo" />
    {children}
  </div>
);

AuthWrapper.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  logo: PropTypes.string.isRequired,
  onKeyPress: PropTypes.func,
};

AuthWrapper.defaultProps = {
  onKeyPress: () => {},
};

export default withStyles(styles)(AuthWrapper);
